module.exports = __webpack_public_path__ + "img/home-sa-gift-of-christmas.45c8ef23.png";